import { render, staticRenderFns } from "./commentsmodal.vue?vue&type=template&id=33eca6de&scoped=true&"
import script from "./commentsmodal.vue?vue&type=script&lang=js&"
export * from "./commentsmodal.vue?vue&type=script&lang=js&"
import style0 from "./commentsmodal.vue?vue&type=style&index=0&id=33eca6de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eca6de",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VDialog,VLayout})
